var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 3.75H16.5V2.25H15V3.75H9V2.25H7.5V3.75H4.5C3.67 3.75 3 4.42 3 5.25V20.25C3 21.08 3.67 21.75 4.5 21.75H19.5C20.33 21.75 21 21.08 21 20.25V5.25C21 4.42 20.33 3.75 19.5 3.75ZM19.5 20.25H4.5V9.75H19.5V20.25ZM19.5 8.25H4.5V5.25H7.5V6.75H9V5.25H15V6.75H16.5V5.25H19.5V8.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalender);
export default __webpack_public_path__ + "static/media/ic-calender.967ecb81d7013b95c716f81bd9c9ba4c.svg";
export { ForwardRef as ReactComponent };